import { userApi } from "../api";

export const {
  useGetUserQuery,
  useCheckPhoneMutation,
  useUpdateMeMutation,
  useUpdateScheduleMutation
} = userApi;
